import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Button, Menu, Modal, Space, Switch, Tooltip, Typography } from "antd";
import { Image } from "antd";
import { createFromIconfontCN } from "@ant-design/icons";
import {
  AppstoreOutlined,
  BarChartOutlined,
  CalendarOutlined,
  DollarOutlined,
  FileTextOutlined,
  FormOutlined,
  GiftOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PictureOutlined,
  ScheduleOutlined,
  TeamOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import LoginComponent from "./features/auth/LoginComponent";
import Register from "./features/register/Register";
import BookList from "./features/booking/BookList";
import Portrait from "./assets/media/IMG_3609.jpeg";
import Regular from "./assets/media/IMG_9363.jpeg";
import Report from "./features/report/Report";
import FAQSection from "./features/public/Faq";
import MonthlySummary from "./features/report/MonthlySummary";
import TimeLogList from "./features/register/TimeLogList";
import WarehousePage from "./features/warehouse/WarehousePage";
import ExpensePage from "./features/expense/ExpensePage";
import GiftPage from "./features/gift/GiftPage";
import UserPage from "./features/users/UserPage";
import PackagePage from "./features/package/PackagePage";
import EmployeeReportPage from "./features/employee-report/EmployeeReportPage";
import PartyOrderPage from "./features/party/PartyOrderPage";
import CanvasOrdersPage from "./features/canvas-orders/CanvasOrdersPage";
const App: React.FC = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    !!localStorage.getItem("accessToken")
  );
  const [isLoginModalVisible, setLoginModalVisible] = useState(false);

  useEffect(() => {
    const checkAuthStatus = () => {
      const accessToken = localStorage.getItem("accessToken");

      if (!accessToken) {
        setIsAuthenticated(false);
        navigate("/login");
      } else {
        setIsAuthenticated(true);
      }
    };

    checkAuthStatus();
  }, [navigate]);

  const IconFont = createFromIconfontCN({
    scriptUrl: "//at.alicdn.com/t/font_8d5l8fzk5b87iudi.js",
  });

  return (
    <div style={{ textAlign: "left" }}>
      {!isAuthenticated && (
        <Button
          style={{ background: "white", color: "black" }}
          type="primary"
          icon={
            <IconFont
              type="icon-tuichu"
              style={{ background: "white", color: "black" }}
            />
          }
          onClick={() => setLoginModalVisible(true)}
        ></Button>
      )}

      <Modal
        title="sign in"
        open={isLoginModalVisible}
        footer={null}
        onCancel={() => setLoginModalVisible(false)}
        centered
      >
        <LoginComponent
          setAuth={(auth) => {
            setIsAuthenticated(auth);
            setLoginModalVisible(!auth);

            if (auth) {
              navigate("/register");
            }
          }}
        />
      </Modal>

      {isAuthenticated ? (
        <MainApp setAuth={setIsAuthenticated} />
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            <Tooltip title="Цаг авах">
              <Image width={300} height={400} src={Portrait} />
              <a
                className="atag"
                href="https://booking.picshot.online"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textDecoration: "none",
                }}
              >
                <Button>Цаг авах</Button>
              </a>
            </Tooltip>

            <Tooltip title="Цаг авах">
              <Image width={300} height={400} src={Regular} />
              <a
                className="atag"
                href="https://booking.picshot.online"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textDecoration: "none",
                }}
              >
                {" "}
                <Button>Цаг авах</Button>
                {/* <CardComponent
                  Portrait={Regular}
                  title={"Энгийн багц"}
                  style={{ flex: "1 1 300px", maxWidth: "250px" }}
                  description={
                    "Энгийн зургын багц (Бүтэн бие гарсан зураг авалттай 4-6 Хүнд тохиромжтой -30мин -60мин -Жирэмсний багц)"
                  }
                /> */}
              </a>
            </Tooltip>
          </div>
          <FAQSection />
        </>
      )}
    </div>
  );
};

export default App;

const MainApp: React.FC<{ setAuth: (auth: boolean) => void }> = ({
  setAuth,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const [theme, setTheme] = useState<"dark" | "light">("light");
  const userRole = localStorage.getItem("userRole");
  const userRealRole = localStorage.getItem("userrealname");

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userrealname");

    setAuth(false);
    navigate("/login");
  };

  const toggleCollapsed = () => setCollapsed(!collapsed);
  const changeTheme = (value: boolean) => setTheme(value ? "dark" : "light");

  useEffect(() => {
    document.body.classList.toggle("is-dark-theme", theme === "dark");

    return () => {
      document.body.classList.remove("is-dark-theme");
    };
  }, [theme]);

  const employeeMenuItems = [
    { label: "Бүртгэх", key: "/register", icon: <FormOutlined /> },
    {
      label: "Бүртгэл харах",
      key: "/bookedList",
      icon: <UnorderedListOutlined />,
    },
    { label: "Gift Cart", key: "/GiftPage", icon: <GiftOutlined /> },
    {
      label: "Canvas захиалга",
      key: "/canvas-orders",
      icon: <PictureOutlined />,
    },
  ];

  const adminMenuItems = [
    { label: "Бүртгэх", key: "/register", icon: <FormOutlined /> },
    {
      label: "Бүртгэл харах",
      key: "/bookedList",
      icon: <UnorderedListOutlined />,
    },
    { label: "Gift Cart", key: "/GiftPage", icon: <GiftOutlined /> },
    {
      label: "Package Management",
      key: "/package",
      icon: <AppstoreOutlined />,
    },
    { label: "Tайлангууд", key: "/Report", icon: <BarChartOutlined /> },
    {
      label: "Агуулах",
      key: "/WarehousePage",
      icon: <CalendarOutlined />,
    },
    { label: "Зардал", key: "/ExpensePage", icon: <DollarOutlined /> },
    { label: "User Management", key: "/users", icon: <TeamOutlined /> },
    { label: "Цалин", key: "/employee-report", icon: <FileTextOutlined /> },
    {
      label: "Event захиалга",
      key: "/party-orders",
      icon: <ScheduleOutlined />,
    },
    {
      label: "Canvas захиалга",
      key: "/canvas-orders",
      icon: <PictureOutlined />,
    },
  ];

  const logoutItem = {
    label: "Logout",
    key: "/logout",
    icon: <LogoutOutlined />,
  };

  const menuItems = [
    ...(userRole === "admin" ? adminMenuItems : employeeMenuItems),
    logoutItem,
  ];

  return (
    <div className={`app-shell ${theme === "dark" ? "is-dark" : "is-light"}`}>
      {/* Sidebar */}
      <div
        className={`app-sidebar ${collapsed ? "is-collapsed" : ""}`}
        style={{ width: collapsed ? 76 : 248 }}
      >
        <div className="app-brand">
          <span className="app-brand-mark">PS</span>
          {!collapsed && (
            <span className="app-brand-text">
              <strong>Picshot</strong>
              <small>Register</small>
            </span>
          )}
        </div>
        <Menu
          theme="light"
          mode="inline"
          inlineCollapsed={collapsed}
          items={menuItems}
          selectedKeys={[location.pathname]}
          className="app-menu"
          onClick={(e) => {
            if (e.key === "/logout") {
              handleLogout();
              return;
            }

            navigate(e.key);
          }}
        />
        <div className={`app-sidebar-tools ${collapsed ? "is-stacked" : ""}`}>
          <Button
            type="primary"
            shape="circle"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={toggleCollapsed}
            className="app-icon-button"
          />

          <Switch
            checked={theme === "dark"}
            onChange={changeTheme}
            checkedChildren="🌙"
            unCheckedChildren="☀️"
          />
        </div>
      </div>

      {/* Main Content */}
      <div className="app-main">
        <header className="app-topbar">
          <div>
            <Typography.Title level={4} className="app-page-title">
              PicShot Self Portrait studio
            </Typography.Title>
            <Typography.Text className="app-page-subtitle">
              Өдөр тутмын бүртгэл болон тайлан
            </Typography.Text>
          </div>
          <Space className="app-user-chip">
            <span className="app-user-dot" />
            <Typography.Text strong>{userRealRole || "User"}</Typography.Text>
          </Space>
        </header>
        <section className="app-content">
          <Routes>
            <Route path="/register" element={<Register theme={theme} />} />
            <Route path="/bookedList" element={<BookList theme={theme} />} />
            <Route path="/GiftPage" element={<GiftPage />} />
            <Route
              path="/canvas-orders"
              element={<CanvasOrdersPage theme={theme} />}
            />
            {/* <Route path="/giftcardlist" element={<GiftCardList />} /> */}
            <Route path="/package" element={<PackagePage />} />

            {/* Admin-only routes */}
            {userRole === "admin" && (
              <>
                <Route path="/users" element={<UserPage />} />
                <Route path="/report" element={<Report theme={theme} />} />
                <Route path="/monthly" element={<MonthlySummary month={""} />} />
                <Route path="/timelist" element={<TimeLogList />} />
                <Route path="/WarehousePage" element={<WarehousePage />} />
                <Route path="/ExpensePage" element={<ExpensePage />} />
                <Route path="/employee-report" element={<EmployeeReportPage />} />
                <Route path="/party-orders" element={<PartyOrderPage />} />
                {/* <Route path="/expense" element={<ExpenseForm />} />
                <Route path="/expenseList" element={<ExpenseList />} /> */}
                {/* <Route path="/warehouse" element={<WareHouse />} /> */}
                {/* <Route path="/chart" element={<ChartComponent />} /> */}
                {/* <Route path="/expenselist" element={<ExpenseList />} /> */}
              </>
            )}
          </Routes>
        </section>
      </div>
    </div>
  );
};
